import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';

export interface SskButton {
  text: string;
  fill?: 'clear' | 'default' | 'outline' | 'solid';
  color?: string;
}

export interface SskConfirmModalProps {
  title?: string;
  description?: string;
  yesBtn: SskButton;
  noBtn: SskButton;
}

@Component({
  selector: 'pos-ssk-confirm-modal',
  templateUrl: './ssk-confirm.modal.html',
  styleUrls: ['./ssk-confirm.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SskConfirmModal {
  @Input() description?: string;
  @Input() title?: string;
  @Input() yesBtn: SskButton;
  @Input() noBtn: SskButton;

  constructor(
    public readonly modalCtrl: ModalController,
    private readonly translocoService: TranslocoService
  ) {
    // Set default translated button labels
    this.yesBtn = { text: this.translocoService.translate('common.yes') };
    this.noBtn = { text: this.translocoService.translate('common.no') };
  }
}
